module.exports = __webpack_public_path__ + "static/media/icon_empresas.dfb0bda7.svg";